import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ApiVisa, BaseApiTemplateService, Core2Config } from "../../shared";


@Injectable({
    providedIn: 'root'
})
export class PaymentVoucherHelperService extends BaseApiTemplateService<any> {
    readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'internal-payment-voucher-import-file-helpers';

    //core2/tnt/dm/erp/internal-payment-voucher-import-file-helpers/backoffice-ep

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'internal-payment-voucher-import-file-helpers';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'internal-payment-voucher-import-file-helpers';
        this.httpClient = http;
    }
}
